import { axiosRetry } from '@/plugins/axios';

const base = '/venues';

export function getTables(venueId, cfg = {}) {
    return axiosRetry.get(`${base}/${venueId}/tables?showAll=false`, {
        timeout: 8000,
        ...cfg
    });
}
